export default "__VITE_ASSET__Bkd350Uv__"